import { useState } from 'react'

import { useAuth } from '../hooks/useAuth'
import ConsignmentDto from '../interfaces/ConsignmentDto.ts'
import { normalizeDate } from '../utils/utils.ts'
import { customPost } from '../utils/customFetch.ts'

import { makeUrlConsignmentCrea } from './connectionData.tsx'
const apiUrl = makeUrlConsignmentCrea()
const useConsignmentCrea = () => {
  const [errorConsignmentCrea, setErrorConsignmentCrea] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const { userData } = useAuth()
  const consignmentCrea = async (conDto: ConsignmentDto) => {
    setLoading(true)

    try {
      // Convertimos antes de enviar
      const consign = {
        ...conDto,
        user_id: userData?.user?._id,
        date: normalizeDate(conDto.date),
      }
      const res = await customPost<{ _id: string }>(apiUrl, consign)

      setErrorConsignmentCrea(null)

      return res._id
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorConsignmentCrea(err)
      } else {
        setErrorConsignmentCrea(new Error('An unknown error occurred'))
      }
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorConsignmentCrea, loading, consignmentCrea }
}
export default useConsignmentCrea
